import {
  EventCartListsOrganism,
  UserEventCartDetailsSideBarOrganism,
  UserEventProfileCustomerOrganism
} from '@/components/atomic/organism';

const UserEventsDetailTemplate = ({
  authUser,
  cartCardList,
  displayUserEventProfile,
  isMobile,
  setShowToast,
  setShowUserEventProfile,
  showUserEventProfile,
  userEvent
}) => (
  <div className='flex flex-col md:flex-row bg-neutral min-h-screen'>
    {userEvent && (
      <UserEventCartDetailsSideBarOrganism
        {...{
          displayUserEventProfile,
          isMobile,
          setShowToast,
          userEvent
        }}
      />
    )}
    <div className='flex-1 px-5 md:pl-5 md:pr-10 relative'>
      {showUserEventProfile && (
        <div className='bg-white my-6 px-6 pt-3 pb-10'>
          <UserEventProfileCustomerOrganism
            {...{
              authUser,
              setShowUserEventProfile,
              userEvent
            }}
          />
        </div>
      )}
      <EventCartListsOrganism {...{ userEventCartList: cartCardList }} />
    </div>
  </div>
);

export default UserEventsDetailTemplate;
